// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__XIAFW","errorLogs":"styles_errorLogs__3zjZD"};